import { useMutation } from '@tanstack/react-query';
import { logActionPromise, LogActionPromiseParam } from 'src/utils';

export const LOG_ACTION_DESCRIPTION_MAP = {
  presence_zone: 'updated presence zone',
  detection_zone: 'updated detection zone',
  exclusion_zone: 'updated exclusion zone',
  copied_presence_zone: 'copied presence zones',
  copied_detection_zone: 'copied detection zones',
  copied_exclusion_zone: 'copied exclusion zones',
} as const;

export const useLogAction = () => {
  const { mutateAsync, isPending, isError } = useMutation({
    mutationFn: logActionPromise,
  });

  const logUserAction = async (params: LogActionPromiseParam) => {
    try {
      await mutateAsync(params);
    } catch (e) {
      console.error(e);
    }
  };

  return {
    logUserAction,
    isLoading: isPending,
    isError,
  };
};
